export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_source_billNo') || '源头单据号',
    field: 'sourceBillNo',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_materialNcNo') || '物料编码',
    field: 'materialNcNo',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'left',
    width: 130,
  },
  {
    title: that.$l('table_label_materialSpec') || '规格型号',
    field: 'materialSpec',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialColor') || '颜色',
    field: 'materialColor',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialUnit') || '单位',
    field: 'materialUnit',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '数量',
    field: 'qty',
    align: 'center',
    width: 115,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_costAmount') || '成本费用',
    field: 'costAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_otherAmount') || '异常的额外',
    field: 'otherAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '费用小计',
    field: 'subAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.table_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_custName') || '客户',
    field: 'custName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 250,
  },
]
